import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { USP_ROW_CONVERTER_TOKEN, UspRowConverter } from './usp-row.component.converter'
import { USP_BOX_CONVERTER_TOKEN, UspBoxConverter } from './usp-box/usp-box.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        uspRowFeature: {
          module: () => import('./usp-row.module').then((m) => m.UspRowModule),
          cmsComponents: ['usprow'],
        },
      }
    }),
    {
      provide: USP_ROW_CONVERTER_TOKEN,
      useClass: UspRowConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        usprow: USP_ROW_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: USP_BOX_CONVERTER_TOKEN,
      useClass: UspBoxConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        uspbox: USP_BOX_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class UspRowFeatureModule {}
